<script>
    import Layout from '../../layouts/main'
    import PageHeader from '@/components/page-header'
    import appConfig from "@/app.config";
        
    export default {
        page: {
            title: "Symptoms",
            meta: [
                {
                name: "description",
                content: appConfig.description,
                },
            ],
        },
        components: { Layout, PageHeader },
        data() {
            return {
                title: "Symptom Questions",
                items: [
                {
                    text: "Doctors",
                    href: "/doctors",
                },   
                {
                    text: "Symptoms",
                    active: true,
                },                   
                ],

                symptoms: [],
                symptom: {
                    id: null,
                    title: "",
                },
                question:{},
                question1:"",

                modal_title: "Add Question",
                button_title: "Save",
                pagination: {},
                edit: false,
                question_status: {
                    id: "",
                    status: "",
                },
                questions:[],
                keyword: "",
                listing_length: 10,
                status: '',
                token: "",
                errors: {},
                activate: false,
                deactivate: false,
                symptom_title:"",
                active_page_url: null,
                option_type:1,
                mandatory:2,
            };
        },
        mounted() {
        
        },
        created() {
            this.fetchQuestions();
        },

        methods: {
            fetchQuestions(page_url = null) {

                this.getToken();
                let url = "clinic/clinic/doctor/symptom_questions?keyword=" + this.keyword + "&limit=" + this.listing_length + "&doctor_id="  + this.$route.params.doctor_id;

                page_url = page_url || url;

                if(localStorage.back_url) {
                    page_url = localStorage.back_url;  
                    localStorage.removeItem('back_url');
                }    

                this.active_page_url = page_url;
                this.loading = true;

                this.$axios
                    .get(page_url, { headers: { Authorization: "Bearer " + this.token } })
                    .then((res) => {
                        var responseData = res.data.data;
                        console.log(responseData);
                        this.questions = responseData.questions.data;
                        this.symptom = responseData.title;
                        console.log(this.symptom);
                        this.pagination = responseData.questions.links;
                        this.from = responseData.questions.from;
                        this.to = responseData.questions.to;
                        this.total = responseData.questions.total;
                    
                })
                .catch((error) => {
                        if (error.response) {
                            if (error.response.data.message) {
                            if(typeof error.response.data.message === 'object') {
                                console.log(error.response.status);
                            } else {
                                this.$swal("", error.response.data.message, "error");
                            }                        
                            
                            } else {
                            this.$swal("", "Something went wrong", "error");
                            }
                        } else {
                            this.$swal("", "Something went wrong", "error");
                        }
                })
                .finally(() => (this.loading = false));
            }, 

            getToken() {
                if (localStorage.getItem('medicino_clinic')) {
                    var medicino_clinic =  JSON.parse(localStorage.getItem('medicino_clinic'));
                    if(medicino_clinic.token) {
                        this.token = medicino_clinic.token;
                    } else {
                        this.$swal("", "Failed to fetch token, please login again", "error");
                        this.$router.push({ name: "login" });
                    }
                    
                } else {
                    this.$swal("", "Session expired, please login again", "error");
                    this.$router.push({ name: "login" });
                }
            }, 

            updateTitle() {
                this.getToken();           
                
                const config = {
                    headers: {
                        "Content-type": "application/json",
                        "Accept": "application/json",
                        "Authorization": "Bearer " + this.token,
                    },
                };

                let formData = new FormData();
                formData.append("doctor_id", this.$route.params.doctor_id); 
                formData.append("title", this.symptom.symptom_title); 
        
                let url = "clinic/clinic/doctor/update_title";
                this.$axios
                .post(url, formData, config)
                .then((response) => {
                    if (response.data.status) {
                        this.$swal("", response.data.message, "success");
                    } else {
                        this.$swal("", response.data.message, "error");
                    }
                    this.hideModal('title-modal');
                    this.fetchQuestions(this.active_page_url);
                })
                .catch((error) => {
                    if (error.response) {
                        if (error.response.data.message) {
                            this.errors = error.response.data.message;
                            // console.log(this.errors);
                            this.$swal("", error.response.data.message, "error");
                        } else {
                            this.$swal("", "Something went wrong", "error");
                        }
                    } else {
                        this.$swal("", "Something went wrong", "error");
                    }
                })
                .finally(() => (this.loading = false));
            },

            addQuestion() {
                this.getToken();           
                
                const config = {
                    headers: {
                        "Content-type": "application/json",
                        "Accept": "application/json",
                        "Authorization": "Bearer " + this.token,
                    },
                };
                let url;
                let formData = new FormData();
                formData.append("doctor_id", this.$route.params.doctor_id); 
                formData.append("question", this.question1); 
                formData.append("option_type", this.option_type); 
                formData.append("mandatory", this.mandatory); 
        
                if(!this.edit) {
                    url = "clinic/clinic/doctor/symptom_question_add";
                    this.active_page_url = null;
                } else {
                    url = "clinic/clinic/doctor/symptom_question_edit";
                    formData.append("question_id", this.question.id);
                } 
                this.$axios
                .post(url, formData, config)
                .then((response) => {
                    if (response.data.status) {
                        this.$swal("", response.data.message, "success");
                    } else {
                        this.$swal("", response.data.message, "error");
                    }
                    this.hideModal('symptom-modal');
                    this.fetchQuestions(this.active_page_url);
                })
                .catch((error) => {
                    if (error.response) {
                        if (error.response.data.message) {
                            this.errors = error.response.data.message;
                            // console.log(this.errors);
                            this.$swal("", error.response.data.message, "error");
                        } else {
                            this.$swal("", "Something went wrong", "error");
                        }
                    } else {
                        this.$swal("", "Something went wrong", "error");
                    }
                })
                .finally(() => (this.loading = false));
            },

            addOption() {
                this.getToken();           
                
                const config = {
                    headers: {
                        "Content-type": "application/json",
                        "Accept": "application/json",
                        "Authorization": "Bearer " + this.token,
                    },
                };
                let url;
                let formData = new FormData();
                formData.append("option", this.symptom.option); 
        
                url = "clinic/clinic/doctor/symptom_options_add";
                formData.append("question_id", this.question.id); 

                this.active_page_url = null;
                this.$axios
                .post(url, formData, config)
                .then((response) => {
                    if (response.data.status) {
                        this.$swal("", response.data.message, "success");
                    } else {
                        this.$swal("", response.data.message, "error");
                    }
                    this.hideModal('subsymptom-modal');
                    this.fetchQuestions(this.active_page_url);
                })
                .catch((error) => {
                    if (error.response) {
                        if (error.response.data.message) {
                            this.errors = error.response.data.message;
                            this.$swal("", error.response.data.message, "error");
                        } else {
                            this.$swal("", "Something went wrong", "error");
                        }
                    } else {
                        this.$swal("", "Something went wrong", "error");
                    }
                })
                .finally(() => (this.loading = false));
            },
            activateQuestion(question) {
                this.activate = false;
                this.$bvModal.msgBoxConfirm('Are you sure you want to publish this Question?', {
                    title: 'Confirm',
                    size: 'sm',
                    buttonSize: 'sm',
                    okVariant: 'danger',
                    okTitle: 'Yes',
                    cancelTitle: 'No',
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true
                })
                .then(value => {
                    this.activate = value
                    if(this.activate){
                    this.question_status.id = question.id;
                    this.question_status.status = 1;
                    this.updateQuestionStatus();
                }
                })
                .catch(err => {
                    console.log(err);
                })
            },
            deactivateQuestion(question) {
                this.deactivate = false;
                this.$bvModal.msgBoxConfirm('Are you sure you want to unpublish this Question?', {
                    title: 'Confirm',
                    size: 'sm',
                    buttonSize: 'sm',
                    okVariant: 'danger',
                    okTitle: 'Yes',
                    cancelTitle: 'No',
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true
                })
                .then(value => {
                    this.deactivate = value
                    if(this.deactivate){
                    this.question_status.id = question.id;
                    this.question_status.status = 2;
                    this.updateQuestionStatus();
                }
                })
                .catch(err => {
                    console.log(err);
                })
            },
            updateQuestionStatus() {
                
                this.getToken();
                const config = {
                headers: {
                    "Content-type": "application/json",
                    "Accept": "application/json",
                    "Authorization": "Bearer " + this.token,
                },
                };     

                let url = "clinic/clinic/doctor/update_symptoms_question_status?question_id=" + this.question_status.id + "&status=" + this.question_status.status;

                this.$axios
                .get(url,config)
                .then((response) => {                  
                    if (response.data.status) {
                        this.$swal("", response.data.message, "success");
                    } else {
                        this.$swal("", response.data.message, "error");
                    }
                    this.fetchQuestions(this.active_page_url);
                })
                .catch((error) => {                
                    if (error.response) {
                        if (error.response.data.message) {
                            this.$swal("", error.response.data.message, "error");
                        } else {
                            this.$swal("", "Something went wrong", "error");
                        }
                    } else {
                        this.$swal("", "Something went wrong", "error");
                    }
                });
            },
            showModal(modal) {
                this.$refs[modal].show();
            },

            hideModal(modal) {
                this.$refs[modal].hide();
            },

            editQuestion(question) {            
                this.modal_title = "Edit Question";
                this.button_title = "Update";
                this.question1 = question.question; 
                this.question.id = question.id;
                this.mandatory = question.mandatory;
                this.option_type = question.option_type;

                this.edit = true;
                this.showModal("symptom-modal");
            },

            addSubQuestionModal(id) {            
                this.question.id = id;
                this.showModal("subsymptom-modal");
            },
            removeQuestion(id) {
                this.delete = false;
                this.$bvModal.msgBoxConfirm('Are you sure you want to remove this question?', {
                    title: 'Confirm',
                    size: 'sm',
                    buttonSize: 'sm',
                    okVariant: 'danger',
                    okTitle: 'Yes',
                    cancelTitle: 'No',
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true
                })
                .then(value => {
                this.delete = value
                if(this.delete){
                    this.getToken();           
                
                    const config = {
                        headers: {
                            "Content-type": "application/json",
                            "Accept": "application/json",
                            "Authorization": "Bearer " + this.token,
                        },
                    };
                    
                    let url = "clinic/clinic/doctor/symptoms/question_remove?question_id=" + id;
                    this.$axios
                    .get(url, config)
                    .then((response) => {
                            if (response.data.status) {
                            this.$swal("", response.data.message, "success");
                            } else {
                            this.$swal("", response.data.message, "error");
                            }
                            this.fetchQuestions(this.active_page_url);
                    })
                    .catch((error) => {
                        if (error.response) {
                            if (error.response.data.message) {
                            this.errors = error.response.data.message;
                            //console.log(this.errors);
                            } else {
                            this.$swal("", "Something went wrong", "error");
                            }
                        } else {
                            this.$swal("", "Something went wrong", "error");
                        }
                    })
                    .finally(() => (this.loading = false));
                }
                })
                .catch(err => {
                console.log(err);
                })
            },

            removeOption(id) {
                this.delete = false;
                this.$bvModal.msgBoxConfirm('Are you sure you want to delete this option?', {
                    title: 'Confirm',
                    size: 'sm',
                    buttonSize: 'sm',
                    okVariant: 'danger',
                    okTitle: 'Yes',
                    cancelTitle: 'No',
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true
                })
                .then(value => {
                this.delete = value
                if(this.delete){
                    this.getToken();           
                
                    const config = {
                        headers: {
                            "Content-type": "application/json",
                            "Accept": "application/json",
                            "Authorization": "Bearer " + this.token,
                        },
                    };
                    
                    let url = "clinic/clinic/doctor/symptoms/option_remove?option_id=" + id;
                    this.$axios
                    .get(url, config)
                    .then((response) => {
                            if (response.data.status) {
                            this.$swal("", response.data.message, "success");
                            } else {
                            this.$swal("", response.data.message, "error");
                            }
                            this.fetchQuestions(this.active_page_url);
                    })
                    .catch((error) => {
                        if (error.response) {
                            if (error.response.data.message) {
                            this.errors = error.response.data.message;
                            //console.log(this.errors);
                            } else {
                            this.$swal("", "Something went wrong", "error");
                            }
                        } else {
                            this.$swal("", "Something went wrong", "error");
                        }
                    })
                    .finally(() => (this.loading = false));
                }
                })
                .catch(err => {
                console.log(err);
                })
            },
            clearForm() {           
                
                this.modal_title = "Add Question";
                this.button_title = "Save";
                this.question1 = "";           
                this.edit = false;
                this.sub_edit = false;
                this.errors = {};
                this.option_type=1,
                this.mandatory=2
            },
        }
    }
</script>
    
<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <!-- <h4 class="card-title"></h4>
                        <p class="card-title-desc"></p> -->

                        <!----- top button area starts---->
                        <div class="row mb-3">
                            <div class="col-12">
                                <a href="#" @click.prevent="$router.go(-1)" class="btn btn-primary float-end"><i class='bx bx-chevrons-left'></i> Back</a>
                                <b-button v-b-modal.symptom-modal variant="primary" class="float-end me-2">Add Question</b-button>
                                <b-button v-b-modal.title-modal variant="primary" class="float-end me-2">Update Title</b-button>

                            </div>
                        </div>
                        <!----- top button area ends---->

                        <!----- Listing length and search starts ----->
                        <div class="row mb-3">
                            <div class="col-sm-12 col-md-6">
                                <div class="listing-length" >
                                <label
                                    >Show
                                    <select class="form-control" v-model="listing_length" @change="fetchQuestions()">
                                        <option value="5">5</option>
                                        <option value="10">10</option>
                                        <option value="15">15</option>
                                    </select>
                                    entries
                                </label>
                                </div>                        
                            </div>
                            <div class="col-sm-12 col-md-6">
                                <div class="listing-filter">
                                <label>
                                    <input type="text" class="form-control" placeholder="Search" v-model="keyword" @keyup="fetchQuestions()"/>
                                </label>
                                </div>                     
                                <!-- <div class="listing-filter me-2">
                                <label>
                                    <select class="form-control" v-model="status">
                                        <option :value="null">All</option>
                                        <option value="1">Published</option>
                                        <option value="0">Unpublished</option>
                                    </select>
                                </label>
                                </div>    -->
                            </div>
                        </div>
                        <!----- Listing length and search ends ----->

                        <!---- listing table starts -------->
                        <div class="table-responsive">
                            <h5>Title : {{ this.symptom.symptom_title }}</h5>
                            <table class="table table-bordered mb-0">
                                <thead class="table-light">
                                    <tr>
                                        <th width="20%">Question</th> 
                                        <th width="25%">Options</th>
                                        <th width="8%">Created On</th>
                                        <th width="15%"></th>
                                    </tr>
                                </thead>
                                <tbody v-if="Boolean(questions.length)">
                                    <tr v-for="(question) in questions" :key="question.id">
                                        <td>{{question.question}}</td>
                                        <td>
                                            <div class="input-tag-questions" v-for="(subquestion, index) in question.subquestions" :key="subquestion.id">
                                                <p>
                                                {{ index + 1 }}. {{ subquestion.sub_question }}
                                                <span @click="removeOption(subquestion.id)" class="text-danger" style="margin-right: 10px;margin-left: 10px;">
                                                    <i class="fas fa-times-circle"></i>
                                                </span>
                                                <!-- <span><i class="fas fa-pencil-alt"></i></span> -->
                                                </p>
                                                <br>
                                            </div>
                                            <!-- <b-button variant="primary" class="btn btn-sm me-2 mb-2" @click="addSubQuestionModal(question.id)">Add options</b-button> -->
                                            <span class="btn btn-outline-primary btn-sm float-end" @click="addSubQuestionModal(question.id)">Add options</span>
                                        </td>                              
                                        <td>{{question.converted_created_at }}</td>
                                        <td>
                                            <b-button variant="primary" class="btn btn-sm me-2 mb-2" @click="editQuestion(question)">Edit</b-button>

                                            <!-- <router-link :to="{ name: 'doctors.symptom.subquestions' , params: {id: question.id} }" class="btn btn-primary me-2 mb-2 btn-sm">Sub Questions</router-link> -->

                                            <b-button v-if="question.status==1" variant="danger" class="btn btn-sm me-2 mb-2" @click="deactivateQuestion(question)">Unpublish</b-button>

                                            <b-button v-else variant="success" class="btn btn-sm me-2 mb-2" @click="activateQuestion(question)">Publish</b-button>                              
                                            <b-button  variant="danger" class="btn btn-sm me-2 mb-2" @click="removeQuestion(question.id)">Remove</b-button>

                                        </td>
                                    </tr>
                        
                                </tbody>
                                <tbody v-else>
                                    <tr>
                                        <td colspan="6" class="text-center">No Questions found</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <!---- listing table ends -------->

                        <!----pagination starts ---> 
                        <caption v-if="Boolean(questions.length)" class="float-start mt-4 d-block d-lg-inline">Showing {{this.from}} to {{this.to}} of {{this.total}} entries</caption>               
                        <ul class="pagination pagination-rounded mt-4 float-lg-end d-md-inline-flex">
                            <li class="page-item "  v-bind:class="[{disabled: !page.url}, {active: page.active}]" v-for="(page, index) in pagination" :key="page.label">
                                <a href="#" class="page-link" @click.prevent="fetchQuestions(page.url + '&limit='+ listing_length + '&keyword=' + keyword+ '&doctor_id=' + this.$route.params.doctor_id)">
                                <i v-if="index == 0" class="mdi mdi-chevron-left"></i>
                                <i v-else-if="index == pagination.length-1" class="mdi mdi-chevron-right"></i>
                                <span v-else>{{page.label}}</span>                          
                                </a>
                            </li>
                        </ul>
                        <!----pagination ends --->
                        
                        <!---- modal starts ---->
                        <b-modal ref="title-modal" id="title-modal" title="Update Title" hide-footer @hidden="clearForm()">
                            <b-form  @submit.prevent="updateTitle()">                        
                                <div class="row"> 
                                <b-col md="12" class="form-group">
                                <label class="control-label">Title<span class="text-danger">*</span></label>
                                <b-form-input v-model="symptom.symptom_title"></b-form-input>
                                </b-col>

                                <b-col md="12" class="mt-3">
                                    <b-button type="submit" class="me-3" variant="primary">Update</b-button>
                                    <b-button class="" variant="light" @click="hideModal('title-modal')">Close</b-button>
                                </b-col>
                                </div>                       
                            </b-form>
                        </b-modal>
                        <!---- modal ends ----->
                            <!---- modal starts ---->
                            <b-modal ref="symptom-modal" id="symptom-modal" :title="modal_title" hide-footer @hidden="clearForm()">
                            <b-form @submit.prevent="addQuestion()">                        
                                <div class="row"> 
                                <b-col md="12" class="form-group">
                                    <label class="control-label">Question<span class="text-danger">*</span></label>
                                    <b-form-input v-model="question1"  v-bind:class="{ 'is-invalid': Boolean(errors.question) }"></b-form-input>
                                    <div v-for="(val, index) in errors.question" :key="index" class="invalid-feedback">
                                            <p class="mb-0">{{ val }}</p>
                                    </div> 
                                </b-col>
                                <div class="col-lg-8">
                                        <div class="form-group">
                                            <label>Option Type</label>
                                            <b-form-radio-group v-model="option_type" >
                                            <div class="form-check-inline">
                                                <b-form-radio name="symptom_needed"  value="1">Single Choice</b-form-radio> 
                                            </div>
                                            <div class="form-check-inline">
                                                <b-form-radio name="symptom_needed" value="2">Multiple Choice</b-form-radio>
                                            </div>
                                            </b-form-radio-group>
                                        </div>
                                </div>
                                <div class="col-lg-4 d-flex align-items-center">
                                    <div>
                                    <div class="form-group">
                                        <label></label>
                                            <b-form-checkbox
                                            v-model="mandatory"
                                            name="mandatory"
                                            value="1"
                                            unchecked-value="2"
                                            >
                                            <span class="ms-2">Mandatory</span>
                                            </b-form-checkbox>
                                        </div>
                                </div>
                                </div>

                                <b-col md="12" class="mt-3">
                                    <b-button type="submit" class="me-3" variant="primary">{{ button_title }}</b-button>
                                    <b-button class="" variant="light" @click="hideModal('symptom-modal')">Close</b-button>
                                </b-col>
                                </div>                       
                            </b-form>
                        </b-modal>
                        <!---- modal ends ----->

                        <!---- modal starts ---->
                        <b-modal ref="subsymptom-modal" id="subsymptom-modal" title="Add Option" hide-footer @hidden="clearForm()">
                            <b-form @submit.prevent="addOption()">                        
                                <div class="row"> 
                                    <b-col md="12" class="form-group">
                                    <label class="control-label">Option<span class="text-danger">*</span></label>
                                    <b-form-input v-model="symptom.option" v-bind:class="{ 'is-invalid': Boolean(errors.question) }"></b-form-input>
                                        <div v-for="(val, index) in errors.question" :key="index" class="invalid-feedback">
                                            <p class="mb-0">{{ val }}</p>
                                        </div>
                                    </b-col>

                                    <b-col md="12" class="mt-3">
                                    <b-button type="submit" class="me-3" variant="primary">{{ button_title }}</b-button>
                                    <b-button class="" variant="light" @click="hideModal('subsymptom-modal')">Close</b-button>
                                    </b-col>
                                </div>                       
                            </b-form>
                        </b-modal>
                        <!---- modal ends ----->

                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>
